import React from 'react';
import { Route, Routes, Link } from 'react-router-dom';
import styles from './styles'

// Import components for each page
import HomePage from './pages/HomePage';

import ContactPage from './pages/ContactPage';

const App: React.FC = () => {
    return (
        <div style={styles.container}>
            <header style={styles.header}>
                <nav style={styles.nav}>
                    <Link to="/" style={styles.button}>Home</Link>
                    <Link to="/contact" style={styles.button}>Contact</Link>
                </nav>
            </header>

            <main style={styles.mainPanel}>
                <Routes>
                    <Route path="/" element={<HomePage />} />
                    <Route path="/contact" element={<ContactPage />} />
                </Routes>
            </main>
        </div>
    );
};

export default App;
